export const JOB_STATUS_META = {
  scheduled: { label: "Scheduled", cls: "border-blue-200 text-blue-600 dark:border-blue-500/30 dark:text-blue-400" },
  in_progress: { label: "In Progress", cls: "border-amber-200 text-amber-600 dark:border-amber-500/30 dark:text-amber-400" },
  completed: { label: "Completed", cls: "border-emerald-200 text-emerald-600 dark:border-emerald-500/30 dark:text-emerald-400" },
  cancelled: { label: "Cancelled", cls: "border-red-200 text-red-600 dark:border-red-500/30 dark:text-red-400" },
};

export const APPOINTMENT_TYPE_LABELS = { service_job: "Service Job", site_visit: "Site Visit" };
export const CUSTOMER_CONFIRMATION_LABELS = { not_contacted: "Not Contacted", awaiting_confirmation: "Awaiting Confirmation", confirmed: "Confirmed" };
export const SOURCE_LABELS = { office: "Office", sales: "Sales" };

export const fmtLocal = (isoLike) => {
  if (!isoLike) return "—";
  const d = new Date(isoLike);
  if (Number.isNaN(d.getTime())) return isoLike;
  return d.toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
};

export const fmtTime = (isoLike) => {
  if (!isoLike) return "—";
  const d = new Date(isoLike);
  if (Number.isNaN(d.getTime())) return isoLike;
  return d.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
};

export const toLocalInputValue = (date) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
